import { EmptyState } from '@/components/patterns/empty-state'
import { Flower } from 'lucide-react'
import OrderCard from './OrderCard'
import type { ComponentProps, ReactElement, Ref } from 'react'
import { useAutoAnimate } from '@formkit/auto-animate/react'

export function OrdersDayView({
  orders,
  hasNextPage = false,
  isFetchingNextPage = false,
  isLoading = false,
  loadMoreRef,
}: {
  orders: ComponentProps<typeof OrderCard>['order'][]
  hasNextPage?: boolean
  isFetchingNextPage?: boolean
  isLoading?: boolean
  loadMoreRef?: Ref<HTMLDivElement>
}): ReactElement {
  const [orderCardParent] = useAutoAnimate({ duration: 250 })

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center pt-10 text-sm text-muted-foreground">
        Loading orders...
      </div>
    )
  }

  if (orders.length === 0) {
    return <EmptyState className="mt-10" size="compact" icon={Flower} title="No orders found" />
  }

  return (
    <>
      <div
        ref={orderCardParent}
        className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4"
      >
        {orders.map((order) => (
          <OrderCard key={order.id} order={order} />
        ))}
      </div>
      <div ref={loadMoreRef} className="flex justify-center py-4">
        <p className="text-xs text-muted-foreground">
          {isFetchingNextPage
            ? 'Loading more orders...'
            : hasNextPage
              ? 'Scroll to load more orders.'
              : "You're all caught up. That's everything for now."}
        </p>
      </div>
    </>
  )
}
